module.exports = __webpack_public_path__ + "img/bian_click_icon.6a17332e.svg";